<template>
  <v-snackbar
    v-model="notification.visible"
    :multi-line="notification.multiline === true"
    bottom
  >
    <v-icon :color="notification.status" class="pr-3">{{ notification.icon }}</v-icon>
    <div>{{ notification.text }}</div>
    <v-btn
      icon
      dark
      flat
      @click="closeNotification"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  computed: {
    notification() {
      return this.$store.state.notifications.notification;
    }
  },
  methods: {
    ...mapMutations(['closeNotification'])
  },
}
</script>

<style>

</style>
